export const esOnboarding = {
  'onboarding.exampleAction': 'Ver un ejemplo',
  'onboarding.exampleDescription': 'Saldo proyectado al final del mes si nada cambia.',
  'onboarding.exampleLabel': 'Ejemplo de resultado',
  'onboarding.expenseAction': 'Agregar gasto fijo',
  'onboarding.expenseDescription':
    'Incluye renta, servicios o cualquier pago que se repita. Así veremos tu punto más bajo.',
  'onboarding.expenseQuestion': '¿Qué pagos se repiten?',
  'onboarding.incomeAction': 'Agregar mi ingreso',
  'onboarding.incomeDescription':
    'Indica cuánto recibes, con qué frecuencia y en cuál wallet entra.',
  'onboarding.incomeQuestion': '¿Cuándo vuelve a entrar dinero?',
  'onboarding.later': 'Ahora no',
  'onboarding.progress': 'Progreso de la primera proyección',
  'onboarding.resume': 'Completar mi primera proyección',
  'onboarding.step': 'Paso {current} de {total}',
  'onboarding.walletAction': 'Confirmar mi wallet',
  'onboarding.walletDescription':
    'Empieza con el dinero que tienes hoy. Puede ser efectivo, una cuenta bancaria o incluso cero.',
  'onboarding.walletQuestion': '¿Dónde está tu dinero hoy?',
} as const;

export const enOnboarding: Record<keyof typeof esOnboarding, string> = {
  'onboarding.exampleAction': 'View an example',
  'onboarding.exampleDescription': 'Projected month-end balance if nothing changes.',
  'onboarding.exampleLabel': 'Example result',
  'onboarding.expenseAction': 'Add fixed expense',
  'onboarding.expenseDescription':
    'Include rent, services, or any repeating payment. This reveals your lowest point.',
  'onboarding.expenseQuestion': 'Which payments repeat?',
  'onboarding.incomeAction': 'Add my income',
  'onboarding.incomeDescription':
    'Enter how much you receive, how often, and which wallet receives it.',
  'onboarding.incomeQuestion': 'When does money come in again?',
  'onboarding.later': 'Not now',
  'onboarding.progress': 'First projection progress',
  'onboarding.resume': 'Complete my first projection',
  'onboarding.step': 'Step {current} of {total}',
  'onboarding.walletAction': 'Confirm my wallet',
  'onboarding.walletDescription':
    'Start with the money you have today. It can be cash, a bank account, or even zero.',
  'onboarding.walletQuestion': 'Where is your money today?',
};
